<div class="tl-container" *ngIf='isAvailableMarkets; else spinner'>
    <tl-futures-markets-toolbar></tl-futures-markets-toolbar>
    <tl-futures-trading-grid></tl-futures-trading-grid>
</div>

<ng-template #spinner>
    <mat-spinner diameter='100'></mat-spinner>
</ng-template>